import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularSplitModule } from 'angular-split';
import { DynamicComponentHostDirective } from '../../../dynamic-component-host/dynamic-component-host.directive';
import { NgTemplateOutlet } from '@angular/common';
import { SplittableDynamicComponentConfig } from '../../model/splittable-dynamic-component-config';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-split-wrapper',
    imports: [AngularSplitModule, DynamicComponentHostDirective, NgTemplateOutlet, MatIconModule, MatButtonModule],
    templateUrl: './split-wrapper.component.html',
    styleUrl: './split-wrapper.component.scss',
    standalone: true
})
export class SplitWrapperComponent {
  @Input() set dynamicComponents(components: SplittableDynamicComponentConfig<any>[]) {
    this.verticalComponents = components?.filter(component => component.direction === 'vertical');
    this.horizontalComponents = components?.filter(component => component.direction === 'horizontal');
  }
  @Output() close = new EventEmitter<SplittableDynamicComponentConfig<any>>();

  verticalComponents: SplittableDynamicComponentConfig<any>[];
  horizontalComponents: SplittableDynamicComponentConfig<any>[];

  onClose(component: SplittableDynamicComponentConfig<any>): void {
    this.close.emit(component);
  }
}
